import type { TransactionActionRunnerId } from '../proposalTypes';
import { structuredModelTransactionActionRunner } from './structuredModelTransactionActionRunner';
import type { TransactionActionRunner } from './types';

// Runner registry: maps each TransactionActionRunnerId to its TransactionActionRunner
// implementation. structured_model is the only transport - every capability shares this one
// runner, which dispatches by capability internally (see structuredModelTransactionActionRunner.ts).
const transactionActionRunners: Record<TransactionActionRunnerId, TransactionActionRunner> = {
  structured_model: structuredModelTransactionActionRunner,
};

export const getTransactionActionRunner = (runnerId: TransactionActionRunnerId): TransactionActionRunner =>
  transactionActionRunners[runnerId];

export type { TransactionActionRunner, TransactionActionRunnerBuildArgs } from './types';
export { structuredModelTransactionActionRunner };
